export const lockStores = [286, 776, 811, 996]